// src/lib/toast.js
// Toast notification utilities
import toast from 'react-hot-toast';
import { getUserMessage } from './errors';

/**
 * Show success toast
 */
export function showSuccess(message, options = {}) {
  return toast.success(message, {
    duration: 3000,
    ...options
  });
}

/**
 * Show error toast
 */
export function showError(error, options = {}) {
  const message = typeof error === 'string' ? error : getUserMessage(error);

  return toast.error(message, {
    duration: 5000,
    ...options
  });
}

/**
 * Show loading toast
 */
export function showLoading(message = 'Loading...', options = {}) {
  return toast.loading(message, options);
}

/**
 * Show info toast
 */
export function showInfo(message, options = {}) {
  return toast(message, {
    duration: 4000,
    icon: 'ℹ️',
    ...options
  });
}

/**
 * Show warning toast
 */
export function showWarning(message, options = {}) {
  return toast(message, {
    duration: 4000,
    icon: '⚠️',
    style: {
      background: '#8b3a2a',
      color: '#faf7f2',
    },
    ...options
  });
}

/**
 * Dismiss a specific toast
 */
export function dismissToast(toastId) {
  toast.dismiss(toastId);
}

/**
 * Dismiss all toasts
 */
export function dismissAllToasts() {
  toast.dismiss();
}

/**
 * Show promise toast (for async operations)
 * Automatically shows loading, success, or error based on promise result
 */
export function showPromiseToast(promise, messages = {}) {
  const {
    loading = 'Loading...',
    success = 'Success!',
    error = 'An error occurred'
  } = messages;

  return toast.promise(promise, {
    loading,
    success,
    error: (err) => {
      return typeof error === 'function' ? error(err) : getUserMessage(err);
    }
  });
}

/**
 * Show toast with custom JSX content
 */
export function showCustom(content, options = {}) {
  return toast.custom(content, options);
}
